module.exports = __webpack_public_path__ + "img/18.435f0e81.jpg";